export default "__VITE_ASSET__BCk8cCom__"